import { reportPageAction } from './reportPageAction';

export const BOOKING_CREATE_JOURNEY = 'booking_create';
export const BOOKING_PLACE_ORDER_JOURNEY = 'booking_place_order';

const clocks = new Map<string, number>();

function canMeasure() {
  return typeof window !== 'undefined' && typeof performance !== 'undefined';
}

export function startJourney(journey: string) {
  if (!canMeasure()) {
    return;
  }

  clocks.set(journey, performance.now());
}

function reportJourney(journey: string, success: boolean) {
  const startTime = clocks.get(journey);
  if (startTime === undefined) {
    return;
  }

  clocks.delete(journey);

  const durationMs = Math.round(performance.now() - startTime);
  if (!Number.isFinite(durationMs) || durationMs < 0) {
    return;
  }

  reportPageAction('journey_timing', {
    journey,
    durationMs,
    success,
  });
}

export function completeJourney(journey: string) {
  reportJourney(journey, true);
}

export function failJourney(journey: string) {
  reportJourney(journey, false);
}

export function cancelJourney(journey: string) {
  clocks.delete(journey);
}
